import { Box } from '@mui/material';

function Separator(): JSX.Element {
  return <Box pt="1em" />;
}

export default Separator;
